import { useEffect } from 'react';

/**
 * Custom hook to set the page meta description dynamically
 * This ensures search engines show the correct description for each page
 */
export const useMetaDescription = (description: string) => {
  useEffect(() => {
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);

    // Update Open Graph description
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', description);

    // Update Twitter description
    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (!twitterDescription) {
      twitterDescription = document.createElement('meta');
      twitterDescription.setAttribute('name', 'twitter:description');
      document.head.appendChild(twitterDescription);
    }
    twitterDescription.setAttribute('content', description);

    // Cleanup function to restore default
    return () => {
      const defaultDescription = 'Recover $100k+ annually with automated no-show reminders and vaccine campaigns. Reduce no-shows by 15% and unlock hidden revenue for your veterinary practice.';
      metaDescription?.setAttribute('content', defaultDescription);
      ogDescription?.setAttribute('content', defaultDescription);
      twitterDescription?.setAttribute('content', defaultDescription);
    };
  }, [description]);
};

